(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("iztro", [], factory);
	else if(typeof exports === 'object')
		exports["iztro"] = factory();
	else
		root["iztro"] = factory();
})(self, () => {
return 